import { Link } from 'react-router-dom';
import { Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    services: [
      { name: '1:1 Sessions', path: '/services/sessions' },
      { name: 'The Studio', path: '/services/studio' },
      { name: 'Equipment', path: '/services/equipment' },
      { name: 'Comprehensive Approach', path: '/services/comprehensive' },
    ],
    info: [
      { name: 'About', path: '/about' },
      { name: 'Pricing', path: '/pricing' },
      { name: 'FAQ', path: '/faq' },
      { name: 'Contact', path: '/contact' },
    ],
  };

  return (
    <footer data-testid="footer" className="bg-stone-900 text-white">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-16">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" data-testid="footer-logo" className="inline-block">
              <h2 className="font-heading text-3xl text-white tracking-tight">TEZR</h2>
            </Link>
            <p className="mt-4 text-stone-400 text-sm leading-relaxed font-light">
              Classical. Contemporary. Complete.
            </p>
            <p className="mt-2 text-stone-400 text-sm leading-relaxed font-light">
              Private Pilates in Kingsland, Auckland.
            </p>
            <a
              href="https://www.instagram.com/tezrpilates"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram"
              className="inline-flex items-center gap-2 mt-6 text-stone-400 hover:text-white transition-colors text-sm"
            >
              <Instagram size={18} strokeWidth={1.5} />
              @tezrpilates
            </a>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-stone-500 font-medium mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-${link.name.toLowerCase().replace(/\s+/g, '-')}`}
                    className="footer-link"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Info */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-stone-500 font-medium mb-6">
              Information
            </h4>
            <ul className="space-y-3">
              {footerLinks.info.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    data-testid={`footer-${link.name.toLowerCase()}`}
                    className="footer-link"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] text-stone-500 font-medium mb-6">
              Location
            </h4>
            <p className="text-stone-400 text-sm leading-relaxed font-light">
              Kingsland, Auckland<br />
              New Zealand
            </p>
            <Link
              to="/contact"
              data-testid="footer-contact-link"
              className="inline-block mt-4 text-sm text-white border-b border-white/50 hover:border-white transition-colors"
            >
              Get in Touch
            </Link>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-stone-800 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-stone-500 text-xs font-light">
            © {currentYear} TEZR Pilates. All rights reserved.
          </p>
          <p className="text-stone-500 text-xs font-light">
            Pilates by Otto Prodan
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
